<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="text-uppercase fw-bolder fs-2 py-10">
        {{ trans("Conditions d'affichage") }}
      </div>
      <div class="btn btn-danger btn-sm" @click="clearRoles">
        Effacer
      </div>
    </div>
    <div>
      <div v-for="roleGroup in roleConditions" class="bg-light-primary rounded border-dashed border-primary p-5 my-5">
        <div class="d-flex flex-wrap">
          <div v-for="(role, index) in roleGroup" class="m-2 bg-success px-5 rounded text-white d-flex align-items-center">
            <select @change="updateValue" :key="helper.generateId()" name="" id="" v-model="role.code" class="form-control form-select-solid form-control-solid bg-transparent border-none text-white fw-bolder py-3 mw-150px">
              <option value="">Selectionnez un role</option>
              <option :value="r.code" v-for="(r, index2) in hierarchy.getRolelist()">
                {{ r.label }}
              </option>
            </select>
            <div>
              <i class="fas fa-times ms-5 text-inherit cursor-pointer text-hover-danger" @click="removeRole(roleGroup, index)"></i>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="btn btn-success btn-sm btn-icon" @click="addRole(roleGroup)">
            <i class="fad fa-plus"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="btn btn-primary btn-sm btn-icon" @click="addConditionGroup">
        <i class="fad fa-plus"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {helper} from "@/services/Helper";
import Swal from "sweetalert2";
import Role from "@/entity/Role";
import {api} from "@/services/Api";

@Component
export default class RoleConditionMaker extends Vue {
  @Prop({default: () => []}) value!: any;

  roleConditions: any[] = [];

  clearRoles() {
    this.$emit('input', [])
  }

  updateValue(){
    this.$emit('input', JSON.parse(JSON.stringify(this.roleConditions)));
  }

  @Watch('value', {immediate: true, deep: true})
  onValueChanged(newVal: string[][][]) {
    this.roleConditions = JSON.parse(JSON.stringify(newVal)) ?? [];
  }

  addConditionGroup() {
    for (let roleGroup of this.roleConditions) {
      if (helper.empty(roleGroup)) {
        Swal.fire({
          title: 'Erreur',
          icon: 'error',
          html: 'Veuillez remplir les conditions vide',
          timer: 10000,
          timerProgressBar: true,
          focusConfirm: false,
        })
        return
      }
    }
    this.roleConditions.push([])
    this.updateValue()
  }


  removeRole(group: any, index: any) {
    group.splice(index, 1)
    this.updateValue()
  }


  mounted() {
    this.loadHierarchy()
  }

  hierarchy: Role = new Role()


  async loadHierarchy() {
    const res = await api.get(api.auth, 'role/list')
    if (res && res.data && res.data.role) {
      this.hierarchy = new Role(res.data.role)
    }
  }


  addRole(group: any) {
    group.push({code: ''})
    this.updateValue()
  }

}
</script>

<style scoped>
h3 {
  color: #2c3e50;
}

button {
  margin-top: 20px;
  padding: 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
}

button:hover {
  background-color: #2980b9;
}
</style>
